// Slow editorial outlined marquee.
export default function Marquee({ dark = false }) {
  const phrase = "PHOTO PIXEL®  —  MEMORIES WORTH FRAMING  —  PRINT · FRAME · GIFT · PRESERVE  —";
  const items = Array.from({ length: 3 });
  return (
    <div
      data-testid="marquee"
      className={`relative overflow-hidden border-y py-8 md:py-12 ${
        dark ? "border-white/10 bg-pp-black" : "border-neutral-200 bg-white"
      }`}
    >
      <div className="pp-marquee">
        {items.concat(items).map((_, i) => (
          <span
            key={i}
            className={`font-display text-5xl md:text-7xl font-black tracking-tight pr-8 ${
              dark ? "text-white" : "text-pp-ink"
            }`}
          >
            {phrase}&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
}
